export const ALERT_PAYMENT_MODE = {
 UPI: "upi",
 NET_BANKING: "nb",
 CC_DC: "cc",
 MOBILE_WALLETS: "wallet",
};


export const ALERT_PAYMENT_MODE_VALUE = {
 UPI: "UPI",
 NET_BANKING: "Net Banking",
 CC_DC: "Credit/Debit card",
 MOBILE_WALLETS: "Mobile Wallets",
 GOOGLE_PAY: "Google Pay",
};

export const ALERT_PAYMENT_STATUS = {
 DISABLE: 0,
 NORMAL: 1,
 WARNING: 2,
 HIDE: 3,
};

export const PAYMENT_ALERT_MESSAGE = {
 PAYMENT_METHOD_EXPERIENCING_ISSUES: "Payment method experiencing issues",
};

// One of these messages needs to be shown when payment alert message status = 3 (Hide)
export const ONE_PAYMENT_ALERT_MESSAGE = " is expriencing a low success rate. Kindly use another way to pay";
export const MORE_PAYMENT_ALERT_MESSAGE = " are expriencing a low success rate. Kindly use another way to pay";
